import { TFunction } from 'i18next'
import moment from 'moment'
import 'moment/locale/fr'

export const formatDiffValue = (value: string, t: TFunction): string => {
  const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/
  if (dateRegex.test(value)) {
    const date = moment(value)
    if (date.isValid()) {
      return date.format('D/MM/YYYY [à] HH:mm')
    }
  }

  if (value === '0') return t('auth.history.value.false', 'Non')
  if (value === '1') return t('auth.history.value.true', 'Oui')
  if (value === 'nil' || value === 'null' || value === '') 
    return t('auth.history.not_provided', 'Non renseigné')

  return value
}

export const formatDate = (dateString: string | null, t: TFunction) => {
  if (!dateString) {
    return t('auth.history.date_unavailable', 'Date non disponible')
  }

  moment.locale('fr')
  const date = moment(dateString)
  if (!date.isValid()) {
    return t('auth.history.date_unavailable', 'Date non disponible')
  }

  return `${t('auth.history.date_prefix', 'Le')} ${date.format('D/MM/YYYY [à] HH:mm')}`
}

export const extractRoleName = (attributeName: string): string => {
  const roleMatch = attributeName.match(/roles\['(.+?)'\]/)
  if (roleMatch && roleMatch[1]) {
    return roleMatch[1]
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase())
  }
  return attributeName
}
